import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getFaqPage = createAsyncThunk('getFaqPage/getFaqPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getFaq();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
